import Head from 'next/head';
import { ProductSchema as IProductSchema } from './interface';
import { processJsonSchema } from '../utils';

interface NewType {
    config: any;
    productMeta: IProductSchema;
}

type Props = NewType;

const ProductSchema = ({ config, productMeta }: Props) => {
    return (
        <Head>
            <script 
                id="product-schema"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: processJsonSchema(config, productMeta)
                }}
            >
                {}
            </script>
        </Head>
    );
};

export default ProductSchema;
